// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: xnPfAjPN6yc
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import NavBar2 from "../../NavBar2"; // plasmic-import: lLCcoonTe6o/component
import Q from "../../Q"; // plasmic-import: n4Ztyh1bnw/component
import ContactDiv from "../../ContactDiv"; // plasmic-import: K63AXAYlTq/component
import Footer from "../../Footer"; // plasmic-import: EvRh7yjThy6/component
import { useScreenVariants as useScreenVariantsrrBukHdQcoc } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: rrBukHDQcoc/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicBasilTiles.module.css"; // plasmic-import: xnPfAjPN6yc/css
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: X9wy9k55W-u/icon
import framepngAd8A8Bcfce7B6636871APngC9UzHwjBvIvQ from "./images/framepngAd8A8Bcfce7B6636871APng.png"; // plasmic-import: C9UZHwjBVIvQ/picture
import frames2PngD6D6A1E201B42E75A604Png97WiBg2IZZbJ from "./images/frames2PngD6D6A1E201B42E75A604Png.png"; // plasmic-import: 97wiBg2iZZbJ/picture
import nounAi2490463Png27Ea3F49B904Ccc14D8FdPngSEEzlXkGyrh from "./images/nounAi2490463Png27Ea3F49B904Ccc14D8FdPng.png"; // plasmic-import: sE_EZLXkGyrh/picture
import nounEthical4351477Png2604F70Ec0Dc48Dc288DbPngDbKcFtXShrHc from "./images/nounEthical4351477Png2604F70Ec0Dc48Dc288DbPng.png"; // plasmic-import: dbKcFtXShrHC/picture
import nounFast3918411Png2E806D61075B7Cd9E57D7PngP83NohmDCdS from "./images/nounFast3918411Png2E806D61075B7Cd9E57D7Png.png"; // plasmic-import: p83nohmD-cdS/picture
import nounReliability373435Png2Eb24445A5Cfdeb311196PngWXjYqNlaaj7 from "./images/nounReliability373435Png2Eb24445A5Cfdeb311196Png.png"; // plasmic-import: WXjYq-Nlaaj7/picture
import _7De497E9D8Fa4A59B211Dbe35Eb005A6PngBptdMfXpaEgn from "./images/_7De497E9D8Fa4A59B211Dbe35Eb005A6Png.png"; // plasmic-import: BptdMFXpaEgn/picture
import d348796242Dd44C7B6AeCe34D9C841E5Png1LoOw4B5PiI3 from "./images/d348796242Dd44C7B6AeCe34D9C841E5Png.png"; // plasmic-import: 1LoOW4B5piI3/picture
import _4583E1944B57490985FbA770Dd37C8CfPng56ShZbfY8PuO from "./images/_4583E1944B57490985FbA770Dd37C8CfPng.png"; // plasmic-import: 56ShZbfY8puO/picture
import selectTilespng60F927F6De90Eb167663PngYcLeM1JoEjY from "./images/selectTilespng60F927F6De90Eb167663Png.png"; // plasmic-import: YcLe_m1joEjY/picture
import databaseTablepng29E504C1D1Eb98E810464PngEs6NhArdEmu from "./images/databaseTablepng29E504C1D1Eb98E810464Png.png"; // plasmic-import: ES6nhARDEmu_/picture

createPlasmicElementProxy;

export const PlasmicBasilTiles__VariantProps = new Array();

export const PlasmicBasilTiles__ArgProps = new Array();

const $$ = {};

function PlasmicBasilTiles__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsrrBukHdQcoc()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__pUw1)}>
            <NavBar2
              data-plasmic-name={"navBar2"}
              data-plasmic-override={overrides.navBar2}
              className={classNames("__wab_instance", sty.navBar2)}
            />

            <div
              data-plasmic-name={"hero"}
              data-plasmic-override={overrides.hero}
              className={classNames(projectcss.all, sty.hero)}
            >
              <div
                data-plasmic-name={"tileFeature"}
                data-plasmic-override={overrides.tileFeature}
                className={classNames(projectcss.all, sty.tileFeature)}
              >
                <div className={classNames(projectcss.all, sty.columns__tAeb)}>
                  <div
                    className={classNames(projectcss.all, sty.column__mmnLi)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__cvSt7)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__eAlg4
                        )}
                      >
                        {"Build a Mosaic of Tailored Insights"}
                      </div>
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__kfJNr
                        )}
                      >
                        {
                          'There is no such thing as "one-size-fits-all" when it comes to the customers and audiences of your organization. We develop Basil Datasets to go deeper and distill millions of particles of data, from journeys to sentiments to demographics and trends, and enable you to build a custom Mosaic that truly represents your customers.'
                        }
                      </div>
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox___6HqI6
                        )}
                      >
                        <PlasmicLink__
                          data-plasmic-name={"greenButton"}
                          data-plasmic-override={overrides.greenButton}
                          className={classNames(
                            projectcss.all,
                            projectcss.a,
                            sty.greenButton
                          )}
                          platform={"react"}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__dnYtF
                            )}
                          >
                            {"Contact Us"}
                          </div>
                        </PlasmicLink__>
                      </div>
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__epkpm)}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img___95DbF)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: framepngAd8A8Bcfce7B6636871APngC9UzHwjBvIvQ,
                        fullWidth: 1200,
                        fullHeight: 831,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              data-plasmic-name={"qs"}
              data-plasmic-override={overrides.qs}
              className={classNames(projectcss.all, sty.qs)}
            >
              <Stack__
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.columns__eexnm)}
              >
                <div className={classNames(projectcss.all, sty.column__rDlp6)}>
                  <Q
                    className={classNames("__wab_instance", sty.q__k7Djr)}
                    slot={
                      "What narratives should we leverage in our next ad campaign?"
                    }
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__oeUxd)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__nBe1Z
                        )}
                      >
                        {"1"}
                      </div>
                    </div>
                  </Q>
                </div>
                <div className={classNames(projectcss.all, sty.column__h6JbO)}>
                  <Q
                    className={classNames("__wab_instance", sty.q__aKd8Z)}
                    slot={
                      "How do our stores compare to stores in other regions?"
                    }
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__li6Td)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__an8Px
                        )}
                      >
                        {"2"}
                      </div>
                    </div>
                  </Q>
                </div>
                <div className={classNames(projectcss.all, sty.column__niRgF)}>
                  <Q
                    className={classNames("__wab_instance", sty.q__bkEa3)}
                    slot={"Where should we place our next location?"}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__bWDqz)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__kFfcX
                        )}
                      >
                        {"3"}
                      </div>
                    </div>
                  </Q>
                </div>
              </Stack__>
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__ui7Ev)}>
              <div
                data-plasmic-name={"tileFeature2"}
                data-plasmic-override={overrides.tileFeature2}
                className={classNames(projectcss.all, sty.tileFeature2)}
              >
                <Stack__
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.columns__q7Lww)}
                >
                  <div
                    className={classNames(projectcss.all, sty.column__fa8Zv)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__un93W)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__bKnGw
                        )}
                      >
                        {"Reflective Consumer Intelligence "}
                      </div>
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__ew2St
                        )}
                      >
                        {
                          "Each of our Datasets starts with a specific geographic or sectoral study area, providing you with a detailed understanding of geo-specific personas; consumer sentiment; and demographics and insights. \n\nFit these insights together to build a mosaic of consumer segments tailored entirely for your business."
                        }
                      </div>
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__jQh5
                        )}
                      >
                        <PlasmicLink__
                          data-plasmic-name={"greenButton2"}
                          data-plasmic-override={overrides.greenButton2}
                          className={classNames(
                            projectcss.all,
                            projectcss.a,
                            sty.greenButton2
                          )}
                          href={`/contact-us`}
                          platform={"react"}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__lqw59
                            )}
                          >
                            {"Contact Us"}
                          </div>
                        </PlasmicLink__>
                      </div>
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column___9EPmj)}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__j1EMw)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: frames2PngD6D6A1E201B42E75A604Png97WiBg2IZZbJ,
                        fullWidth: 1279,
                        fullHeight: 669,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                </Stack__>
              </div>
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__woTcp)}>
            <section
              data-plasmic-name={"sectors"}
              data-plasmic-override={overrides.sectors}
              className={classNames(projectcss.all, sty.sectors)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__wyoMi
                )}
              >
                {hasVariant(globalVariants, "screen", "mobileOnly")
                  ? "What sets Basil Data Tiles Apart"
                  : "What sets Basil Tiles Apart"}
              </div>
              <Stack__
                as={"div"}
                data-plasmic-name={"foreground"}
                data-plasmic-override={overrides.foreground}
                hasGap={true}
                className={classNames(projectcss.all, sty.foreground)}
              >
                <Stack__
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox___5Bfd7)}
                >
                  <Stack__
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.columns___0LxwW)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.column__pfT0Z)}
                    >
                      <div
                        data-plasmic-name={"item"}
                        data-plasmic-override={overrides.item}
                        className={classNames(projectcss.all, sty.item)}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__k4Qwk
                          )}
                        >
                          <PlasmicImg__
                            alt={""}
                            className={classNames(sty.img__zuAyG)}
                            displayHeight={"auto"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"none"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"auto"}
                            loading={"lazy"}
                            src={{
                              src: nounAi2490463Png27Ea3F49B904Ccc14D8FdPngSEEzlXkGyrh,
                              fullWidth: 562,
                              fullHeight: 559,
                              aspectRatio: undefined
                            }}
                          />
                        </div>
                        <Stack__
                          as={"div"}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__iGtuq
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__lmk3
                            )}
                          >
                            {"Harder"}
                          </div>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__wVX2
                            )}
                          >
                            {
                              "We build cutting-edge technology to synthesize millions of data points specifically catered to your business."
                            }
                          </div>
                        </Stack__>
                      </div>
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.column__ggZ9)}
                    >
                      <div
                        data-plasmic-name={"item2"}
                        data-plasmic-override={overrides.item2}
                        className={classNames(projectcss.all, sty.item2)}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__b1SGz
                          )}
                        >
                          <PlasmicImg__
                            alt={""}
                            className={classNames(sty.img__gKsX)}
                            displayHeight={"auto"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"100px"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"auto"}
                            loading={"lazy"}
                            src={{
                              src: nounEthical4351477Png2604F70Ec0Dc48Dc288DbPngDbKcFtXShrHc,
                              fullWidth: 590,
                              fullHeight: 590,
                              aspectRatio: undefined
                            }}
                          />
                        </div>
                        <Stack__
                          as={"div"}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__oyqWy
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__bBy9
                            )}
                          >
                            {"Better"}
                          </div>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__xIOy6
                            )}
                          >
                            {
                              "We use ethical and sustainable technologies to help make an ethical future of consumer analytics a reality."
                            }
                          </div>
                        </Stack__>
                      </div>
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.column__huXAl)}
                    >
                      <div
                        data-plasmic-name={"item3"}
                        data-plasmic-override={overrides.item3}
                        className={classNames(projectcss.all, sty.item3)}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__mJtB1
                          )}
                        >
                          <PlasmicImg__
                            alt={""}
                            className={classNames(sty.img__gU2Z2)}
                            displayHeight={"auto"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"none"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"auto"}
                            loading={"lazy"}
                            src={{
                              src: nounFast3918411Png2E806D61075B7Cd9E57D7PngP83NohmDCdS,
                              fullWidth: 577,
                              fullHeight: 577,
                              aspectRatio: undefined
                            }}
                          />
                        </div>
                        <Stack__
                          as={"div"}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__sPyA2
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__zkgAp
                            )}
                          >
                            {"Faster"}
                          </div>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__lqn4M
                            )}
                          >
                            {
                              "We provide current, accurate insights that your organization can act on as global and local situations evolve."
                            }
                          </div>
                        </Stack__>
                      </div>
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.column__urP5B)}
                    >
                      <div
                        data-plasmic-name={"item4"}
                        data-plasmic-override={overrides.item4}
                        className={classNames(projectcss.all, sty.item4)}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__pEmF4
                          )}
                        >
                          <PlasmicImg__
                            alt={""}
                            className={classNames(sty.img__rCvEg)}
                            displayHeight={"auto"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"100px"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"auto"}
                            loading={"lazy"}
                            src={{
                              src: nounReliability373435Png2Eb24445A5Cfdeb311196PngWXjYqNlaaj7,
                              fullWidth: 551,
                              fullHeight: 551,
                              aspectRatio: undefined
                            }}
                          />
                        </div>
                        <Stack__
                          as={"div"}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__asPr8
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__fuF0R
                            )}
                          >
                            {"Stronger"}
                          </div>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___3EFmg
                            )}
                          >
                            {
                              "We develop robust, in-depth insights that are grounded on real places and communities."
                            }
                          </div>
                        </Stack__>
                      </div>
                    </div>
                  </Stack__>
                </Stack__>
              </Stack__>
            </section>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__hAoEm)}>
            <div className={classNames(projectcss.all, sty.freeBox___82S8R)}>
              <div className={classNames(projectcss.all, sty.freeBox__aCciA)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___4Jqt
                  )}
                >
                  {"How we engage clients"}
                </div>
                <div
                  data-plasmic-name={"qs2"}
                  data-plasmic-override={overrides.qs2}
                  className={classNames(projectcss.all, sty.qs2)}
                >
                  <Stack__
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.columns__kaWxt)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.column__nhGdk)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__yHl5E
                        )}
                      >
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__kSoI)}
                          displayHeight={"50px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"50px"}
                          loading={"lazy"}
                          src={{
                            src: _7De497E9D8Fa4A59B211Dbe35Eb005A6PngBptdMfXpaEgn,
                            fullWidth: 68,
                            fullHeight: 77,
                            aspectRatio: undefined
                          }}
                        />

                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__slBYe
                          )}
                        >
                          {"Iterate together"}
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text___55AkE
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <ul
                                className={classNames(
                                  projectcss.all,
                                  projectcss.ul,
                                  sty.ul__stxE
                                )}
                              >
                                <li
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.li,
                                    projectcss.__wab_text,
                                    sty.li__yPr7Q
                                  )}
                                >
                                  {
                                    "We built Basil lean and agile with the desire to bring this same attitude to our work with clients. "
                                  }
                                </li>
                                <li
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.li,
                                    projectcss.__wab_text,
                                    sty.li__ovhAl
                                  )}
                                >
                                  {
                                    "We work one-on-one with your team and make sure that we always have an open line of communication with whichever collaboration platform you use (e.g. Teams, Slack)."
                                  }
                                </li>
                              </ul>
                            }

                            <React.Fragment>{""}</React.Fragment>
                          </React.Fragment>
                        </div>
                      </div>
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.column___3OXeg)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__jWjY
                        )}
                      >
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__fgeKd)}
                          displayHeight={"50px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"50px"}
                          loading={"lazy"}
                          src={{
                            src: d348796242Dd44C7B6AeCe34D9C841E5Png1LoOw4B5PiI3,
                            fullWidth: 91,
                            fullHeight: 91,
                            aspectRatio: undefined
                          }}
                        />

                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__cmHuA
                          )}
                        >
                          {"Data to match your KPIs"}
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__tSsIo
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <ul
                                className={classNames(
                                  projectcss.all,
                                  projectcss.ul,
                                  sty.ul__bkhGn
                                )}
                              >
                                <li
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.li,
                                    projectcss.__wab_text,
                                    sty.li__i6SL4
                                  )}
                                >
                                  {
                                    "The better we understand your business, the better we can match our data with your KPIs."
                                  }
                                </li>
                                <li
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.li,
                                    projectcss.__wab_text,
                                    sty.li__jp4Pb
                                  )}
                                >
                                  {
                                    "On the onset of a project, we engage clients in collaborative brainstorms to establish topics and personas to track (e.g. \u201cStaff sentiment,\u201d \u201cPrice conscious shoppers\u201d) that match KPIs."
                                  }
                                </li>
                              </ul>
                            }

                            <React.Fragment>{""}</React.Fragment>
                          </React.Fragment>
                        </div>
                      </div>
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.column___7O0H6)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__iPdMb
                        )}
                      >
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__k2Qss)}
                          displayHeight={"50px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"50px"}
                          loading={"lazy"}
                          src={{
                            src: _4583E1944B57490985FbA770Dd37C8CfPng56ShZbfY8PuO,
                            fullWidth: 91,
                            fullHeight: 91,
                            aspectRatio: undefined
                          }}
                        />

                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__hgt5M
                          )}
                        >
                          {"Deep dives to drive actionability"}
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text___39Yf
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <ul
                                className={classNames(
                                  projectcss.all,
                                  projectcss.ul,
                                  sty.ul___9Rhxk
                                )}
                              >
                                <li
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.li,
                                    projectcss.__wab_text,
                                    sty.li__zutll
                                  )}
                                >
                                  {
                                    "Testable hypotheses are critical to successful data exploration."
                                  }
                                </li>
                                <li
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.li,
                                    projectcss.__wab_text,
                                    sty.li__beQu
                                  )}
                                >
                                  {
                                    "As these hypotheses are revised, we encourage the development of \u201cdeep dives\u201d to make our insights as actionable as possible (e.g. if data shows that \u201cStaff\u201d correlates most strongly to overall ratings, what sub-topics drive \u201cStaff\u201d?)"
                                  }
                                </li>
                              </ul>
                            }

                            <React.Fragment>{""}</React.Fragment>
                          </React.Fragment>
                        </div>
                      </div>
                    </div>
                  </Stack__>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__ehnOd)}>
                <div
                  data-plasmic-name={"tileFeature4"}
                  data-plasmic-override={overrides.tileFeature4}
                  className={classNames(projectcss.all, sty.tileFeature4)}
                >
                  <div
                    className={classNames(projectcss.all, sty.columns__gzqtK)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.column__csKEg)}
                    >
                      <PlasmicImg__
                        alt={""}
                        className={classNames(sty.img__mImQ6)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: selectTilespng60F927F6De90Eb167663PngYcLeM1JoEjY,
                          fullWidth: 1256,
                          fullHeight: 816,
                          aspectRatio: undefined
                        }}
                      />
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.column__tHfPj)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox___7HDbS
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__g38R
                          )}
                        >
                          {"Engineered for Depth "}
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__dxD1J
                          )}
                        >
                          {
                            "Basil Datasets are designed to go deeper into a portfolio, geography, or segmentation than anything that currently exists in the industry. Our Datasets map consumer journeys and pinpoint what they value at your locations as well as your competitors. \n\nThese insights are designed to provide you with a nuanced, yet scalable understanding of the underlying motivations, behaviours and patterns that drive your consumers."
                          }
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__h5DpW
                          )}
                        >
                          <PlasmicLink__
                            data-plasmic-name={"greenButton5"}
                            data-plasmic-override={overrides.greenButton5}
                            className={classNames(
                              projectcss.all,
                              projectcss.a,
                              sty.greenButton5
                            )}
                            href={`/contact-us`}
                            platform={"react"}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__quThF
                              )}
                            >
                              {"Contact Us"}
                            </div>
                          </PlasmicLink__>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Stack__
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__xf1FG)}
              >
                <Stack__
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__hm5Fw)}
                >
                  <Stack__
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__rF6I)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__eWbGg)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__bsRwU
                        )}
                      >
                        {"Our Services"}
                      </div>
                    </div>
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__zqxrD
                      )}
                    >
                      {
                        "Nascetur nascetur ridiculus scelerisque adipiscing a nascetur varius sed eu a ad semper a est nec litora ante at orci rhoncus a varius auctor aliquam inceptos vestibulum ridiculus."
                      }
                    </div>
                  </Stack__>
                  <Stack__
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__lfQis)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__xLxeD)}
                    >
                      <Stack__
                        as={"div"}
                        hasGap={true}
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__xJn5O
                        )}
                      >
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__ap71P)}
                          displayHeight={"auto"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"200px"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={
                            hasVariant(globalVariants, "screen", "mobileOnly")
                              ? "50%"
                              : "30%"
                          }
                          loading={"lazy"}
                          src={{
                            src: selectTilespng60F927F6De90Eb167663PngYcLeM1JoEjY,
                            fullWidth: 1256,
                            fullHeight: 816,
                            aspectRatio: undefined
                          }}
                        />

                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__qn131
                          )}
                        >
                          {hasVariant(globalVariants, "screen", "mobileOnly")
                            ? "Custom Data Tiles"
                            : "Datasets"}
                        </div>
                        <Stack__
                          as={"div"}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__wu4K2
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__gtGw0
                            )}
                          >
                            <React.Fragment>
                              <React.Fragment>{""}</React.Fragment>
                              {
                                <Stack__
                                  as={"ul"}
                                  hasGap={true}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.ul,
                                    sty.ul___0MWkk
                                  )}
                                >
                                  <li
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.li,
                                      projectcss.__wab_text,
                                      sty.li__l8PLh
                                    )}
                                  >
                                    {
                                      "Quantify and map the consumer journeys and sentiments of your customers\n"
                                    }
                                  </li>
                                  <li
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.li,
                                      projectcss.__wab_text,
                                      sty.li___8B2Sp
                                    )}
                                  >
                                    {
                                      "Insights on demographics and consumer personas"
                                    }
                                  </li>
                                </Stack__>
                              }

                              <React.Fragment>{""}</React.Fragment>
                            </React.Fragment>
                          </div>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__ndsGu
                            )}
                          >
                            {"All the basics"}
                          </div>
                        </Stack__>
                        <Stack__
                          as={PlasmicLink__}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            projectcss.a,
                            sty.link__evIr4
                          )}
                          href={`/contact-us`}
                          platform={"react"}
                        >
                          {false ? (
                            <IconIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg___7M2Av
                              )}
                              role={"img"}
                            />
                          ) : null}
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__vrchW
                            )}
                          >
                            {"Contact Us"}
                          </div>
                          {false ? (
                            <IconIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg___50O6W
                              )}
                              role={"img"}
                            />
                          ) : null}
                        </Stack__>
                      </Stack__>
                    </div>
                    <div
                      data-plasmic-name={"line"}
                      data-plasmic-override={overrides.line}
                      className={classNames(projectcss.all, sty.line)}
                    />

                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox___8TM62
                      )}
                    >
                      <Stack__
                        as={"div"}
                        hasGap={true}
                        className={classNames(
                          projectcss.all,
                          sty.freeBox___935Pj
                        )}
                      >
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__yWmUt)}
                          displayHeight={"auto"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"200px"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={
                            hasVariant(globalVariants, "screen", "mobileOnly")
                              ? "50%"
                              : "30%"
                          }
                          loading={"lazy"}
                          src={{
                            src: databaseTablepng29E504C1D1Eb98E810464PngEs6NhArdEmu,
                            fullWidth: 1296,
                            fullHeight: 856,
                            aspectRatio: undefined
                          }}
                        />

                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__yeoDt
                          )}
                        >
                          {"Consumer Sentiment\nDatabase"}
                        </div>
                        <Stack__
                          as={"div"}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__jwdj0
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___8An6T
                            )}
                          >
                            {"Best deal"}
                          </div>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___6PG7
                            )}
                          >
                            <React.Fragment>
                              <React.Fragment>{""}</React.Fragment>
                              {
                                <Stack__
                                  as={"ul"}
                                  hasGap={true}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.ul,
                                    sty.ul__k5Kcm
                                  )}
                                >
                                  <li
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.li,
                                      projectcss.__wab_text,
                                      sty.li__kHvbQ
                                    )}
                                  >
                                    {
                                      "Access a database benchmarking every retailer and public location in your city"
                                    }
                                  </li>
                                  <li
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.li,
                                      projectcss.__wab_text,
                                      sty.li__l8Kv0
                                    )}
                                  >
                                    {
                                      "Access to segmentation-specific Datasets, which show patterns of the most prevalent consumer groups relevant to your study."
                                    }
                                  </li>
                                </Stack__>
                              }

                              <React.Fragment>{""}</React.Fragment>
                            </React.Fragment>
                          </div>
                        </Stack__>
                        <Stack__
                          as={PlasmicLink__}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            projectcss.a,
                            sty.link__bbvvD
                          )}
                          href={`/contact-us`}
                          platform={"react"}
                        >
                          {false ? (
                            <IconIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg___6Me0N
                              )}
                              role={"img"}
                            />
                          ) : null}
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__ldWdG
                            )}
                          >
                            {"Contact Us"}
                          </div>
                          {false ? (
                            <IconIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg__drmv
                              )}
                              role={"img"}
                            />
                          ) : null}
                        </Stack__>
                      </Stack__>
                    </div>
                  </Stack__>
                </Stack__>
              </Stack__>
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__cd7CO)}>
            <div className={classNames(projectcss.all, sty.freeBox__w8SUg)}>
              <div className={classNames(projectcss.all, sty.freeBox__vEUyD)}>
                <ContactDiv
                  data-plasmic-name={"contactDiv"}
                  data-plasmic-override={overrides.contactDiv}
                  className={classNames("__wab_instance", sty.contactDiv)}
                />

                <Footer
                  data-plasmic-name={"footer"}
                  data-plasmic-override={overrides.footer}
                  className={classNames("__wab_instance", sty.footer)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "navBar2",
    "hero",
    "tileFeature",
    "greenButton",
    "qs",
    "tileFeature2",
    "greenButton2",
    "sectors",
    "foreground",
    "item",
    "item2",
    "item3",
    "item4",
    "qs2",
    "tileFeature4",
    "greenButton5",
    "line",
    "contactDiv",
    "footer"
  ],

  navBar2: ["navBar2"],
  hero: ["hero", "tileFeature", "greenButton"],
  tileFeature: ["tileFeature", "greenButton"],
  greenButton: ["greenButton"],
  qs: ["qs"],
  tileFeature2: ["tileFeature2", "greenButton2"],
  greenButton2: ["greenButton2"],
  sectors: ["sectors", "foreground", "item", "item2", "item3", "item4"],
  foreground: ["foreground", "item", "item2", "item3", "item4"],
  item: ["item"],
  item2: ["item2"],
  item3: ["item3"],
  item4: ["item4"],
  qs2: ["qs2"],
  tileFeature4: ["tileFeature4", "greenButton5"],
  greenButton5: ["greenButton5"],
  line: ["line"],
  contactDiv: ["contactDiv"],
  footer: ["footer"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicBasilTiles__ArgProps,
          internalVariantPropNames: PlasmicBasilTiles__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicBasilTiles__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicBasilTiles";
  } else {
    func.displayName = `PlasmicBasilTiles.${nodeName}`;
  }
  return func;
}

export const PlasmicBasilTiles = Object.assign(
  // Top-level PlasmicBasilTiles renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    navBar2: makeNodeComponent("navBar2"),
    hero: makeNodeComponent("hero"),
    tileFeature: makeNodeComponent("tileFeature"),
    greenButton: makeNodeComponent("greenButton"),
    qs: makeNodeComponent("qs"),
    tileFeature2: makeNodeComponent("tileFeature2"),
    greenButton2: makeNodeComponent("greenButton2"),
    sectors: makeNodeComponent("sectors"),
    foreground: makeNodeComponent("foreground"),
    item: makeNodeComponent("item"),
    item2: makeNodeComponent("item2"),
    item3: makeNodeComponent("item3"),
    item4: makeNodeComponent("item4"),
    qs2: makeNodeComponent("qs2"),
    tileFeature4: makeNodeComponent("tileFeature4"),
    greenButton5: makeNodeComponent("greenButton5"),
    line: makeNodeComponent("line"),
    contactDiv: makeNodeComponent("contactDiv"),
    footer: makeNodeComponent("footer"),
    // Metadata about props expected for PlasmicBasilTiles
    internalVariantProps: PlasmicBasilTiles__VariantProps,
    internalArgProps: PlasmicBasilTiles__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "Basil Labs Data Tiles",
      description: "How consumer analytics should be in the 21st century",
      ogImageSrc:
        "https://site-assets.plasmic.app/33d1cf7aecefcec7ed7098f1ae83d3c8.png",
      canonical: ""
    }
  }
);

export default PlasmicBasilTiles;
/* prettier-ignore-end */
